export default __webpack_public_path__ + "static/card-8-a5f22d7b9e09b965789cd9a2d6b4de17.png";